import React, {PureComponent} from "react"
import styled, {css} from "styled-components"

import Card from "@irati/ui/src/Layout/Card"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {Input} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${({theme}) => theme.colors.utility.subdued};
  border-radius: ${({theme}) => theme.border.radius.small};
  padding: ${({theme}) => theme.spacing.two};
`

const StyledCard = styled(Card)`
  max-width: 500px;
  margin: 0 auto;
  ${({theme}) => css`
    box-shadow: ${theme.shadows.low};
    ${theme.mediaQueries.minWidthMedia.tablet`
      margin-top: 60px;
    `}
    ${theme.mediaQueries.minWidthMedia.desktop`
      margin-top: 30px;
    `}
  `}
`

class BannerLink extends PureComponent {
  render() {
    return (
      <StyledCard>
        <Wrapper>
          <Icon icon={IconTypes.search} marginRight={2} />
          <Input><FormattedMessage id="recognition.banner.link.text" /></Input>
        </Wrapper>
      </StyledCard>
    )
  }
}

export default BannerLink
